module.exports = __webpack_public_path__ + "static/mgmt-consulting-banner-5161ff78cb144cc4deae5af0adee7254.jpg";